import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';

// styles applied to the markdown generated html
// note, includes the following as these are all generated by the markdown, even though should be separate emotion components:
// - cards
// - data-access search box
// - toc
// - header / header-anchor

// eslint-disable-next-line import/prefer-default-export
export const typography = css`

  position: relative;
  margin-left: 10px;

  /*header area of api package pages */
  div.package-landing-header {
    position: relative;
    h1 {
      display: inline-block;
    }
    p {
      position: absolute;
      top: -40px;
      right: 20px;
      display: inline-block;
      ${media('<tablet')} { display: none; }
      ${media('<desktop')} {
        top: -20px;
      }
      img {
        width: 120px;
        height: 120px;
        ${media('<desktop')} {
          width: 80px;
          height: 80px;
        }
      }
    }
  }

  /* api cards - duplicating the cards found on the landing page, but within the markdown content we can't use emotion at the element level */
  ol.package-cards-wrapper {
    padding-left: 0px !important;
    padding-top: 32px;
    margin-bottom: 6px;
    ${media('>=tablet')} {
      padding-top: 36px;
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      margin: 0 -12px;
      margin-bottom: 16px;
    }
    ${media('>=desktop')} {
      margin-bottom: 35px;
    }

    li {
      background: #F1FBFB;
      border-radius: 2px;
      h3 {
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 0px;
      }
      ${media('<tablet')} {
        position: relative;
        display: block;
        width: 100%;
        height: 100px;
        margin-bottom: 6px;
        h3 {
          position: absolute;
          top: 38px;
          left: 116px;
        }
        p {
          display: none;
        }
      }

      ${media('>=tablet')} {
        flex-basis: 44%;
        display: inline-block;
        flex-direction: column;
        width: 224px;
        min-height: 310px;
        margin-left: 6px;
        margin-right: 6px;
        margin-bottom: 18px;
        p {
          font-size: 14px;
          margin: 0px;
          padding-top: 6px;
        }
      }

      ${media('>=desktop')} {
        flex-basis: 30%;
        margin-left: 12px;
        margin-right: 12px;
        min-height: 280px;
      }

      img {
        width: 77px;
        height: 66px;
        ${media('<tablet')} {
          position: absolute;
          top: 20px;
          left: 20px;
        }
      }

      a {
        text-decoration: none;
        display: block;
        width: 100%;
        height: 100%;
        position: relative;
        color: ${variables.colour.neutral700};
        ${media('>=tablet')} {
          padding: 36px 36px 18px 36px ;
          display: flex;
          flex-direction: column;
          flex-wrap: no-wrap;
          div.flex-space {
            flex-grow: 1;
          }
          img {
            align-self: flex-start;
          }
        }
      }
    }
  }

  /*
  - specifically supported icons
  - default block size for resize prevention
  */
  i.material-icons {
    display: inline-block;
    width: 24px;
    height: 24px;

    /* used on aside */
    &.info_outline {
      ::before { content: "info_outline" }
    }
    &.error_outline {
      ::before { content: "error_outline" }
    }
    &.check_circle_outline {
      ::before { content: "check_circle_outline" }
    }

    /* used on the data browser */
    &.check {
      ::before { content: "check" }
    }
    &.clear {
      ::before { content: "clear" }
    }
    &.view_list {
      ::before { content: "view_list" }
    }

    /*used on intro page cards...*/
    &.select_all {
      ::before { content: "select_all" }
    }
    &.security {
      ::before { content: "security" }
    }
    &.domain {
      ::before { content: "domain" }
    }
    &.center_focus_strong {
      ::before { content: "center_focus_strong" }
    }
  }

  ${media('>=tablet')} {
    margin-left: 20px;
  }

  ${media('>=desktop')} {
    margin-left: 30px;
  }

  .table-of-contents {
    display: none;
    padding-top: 20px;
    padding-bottom: 10px;
    > ol {
      padding-top: 6px;
      padding-left: 0.4rem;
      position: relative;
      li:first-of-type {
        ::before {
          content "On this page:";
          font-weight: bold;
          position: absolute;
          top: -24px;
          left: -6px;
        }
      }
    }

    ${media('<tablet')} {
      display: block;
    }
  }

  strong {
    font-weight: bold;
  }


  hr {
    border: 0;
    height: 1px;
    background: ${variables.colour.neutral600};
  }


  h1 {
    font-size: ${variables.font.h1MobileFontSize};
    line-height: ${variables.font.h1MobileLineHeight};
    font-weight: bold;
    margin-bottom: 18px;
    @media (min-width: ${variables.global.desktopMinWidth}) {
      font-size: ${variables.font.h1FontSize};
      line-height: ${variables.font.h1LineHeight};
    }
  }



  h2 {
    font-size: ${variables.font.h2MobileFontSize};
    line-height: ${variables.font.h2MobileLineHeight};
    font-weight: bold;
    margin-bottom: 18px;
    @media (min-width: ${variables.global.desktopMinWidth}) {
      font-size: ${variables.font.h2FontSize};
      line-height: ${variables.font.h2LineHeight};
    }
  }

  h3, h4, h5 {
    font-size: ${variables.font.h3MobileFontSize};
    line-height: ${variables.font.h3MobileLineHeight};
    font-weight: bold;
    margin-bottom: 18px;
    @media (min-width: ${variables.global.desktopMinWidth}) {
      font-size: ${variables.font.h3FontSize};
      line-height: ${variables.font.h3LineHeight};
    }
  }

  h1, h2, h3 {
    position: relative;
    padding-left: 24px;
    padding-top: 6px;
    margin-left: -24px;
    a.header-anchor {
      position: absolute;
      margin-left: -24px;
      display: none;
      text-decoration: none;
      color: ${variables.colour.neutral600};
      font-weight: normal;
      font-size: ${variables.font.h4FontSize};
      vertical-align: top;
      :hover {
        text-decoration: underline;
      }
    }
    :hover {
      a.header-anchor {
        ${media('>=tablet')} {
          display: inline;
        }
      }
    }
  }

  blockquote {
    margin: 20px 0;
    padding-left: 1rem;
    border-left: 5px solid ${variables.colour.secondary}
  }

  .cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    > .card {
      :hover {
        box-shadow: 0 0.5rem 1rem 0.2rem rgba(0,0,0,.2);
      }
      display: flex;
      align-items: flex-start;
      width: 90%;
      text-decoration: none;
      color: black;
      box-shadow: 0 0.5rem 0.5rem 0.2rem rgba(0,0,0,.1);
      margin: 0.7rem;
      padding: 1rem;
      i.icon {
        font-size: ${variables.font.h2FontSize};
        color: ${variables.colour.neutral600};
        padding-right: 6px;
        display: inline-block;
        width: 46px;
        height: 39px;
      }
      .content {
        h4 {
          margin-left: 0px;
          padding-left: 0px;
          font-size: ${variables.font.h3FontSize};
          color: ${variables.colour.secondary};
          :hover {
            > a.header-anchor {
              display: none;
            }
          }
        }
      }
      ${media('>=desktop')} {
        width: 40%;
      }
    }
  }

  code {
    color: #cb4b16;
    overflow-x: auto;
    &.hljs {
      display: block;
      padding: 10px;
      background-color: #fdf6e3
    }
  }

  pre {

  }

  table {
    width: 100%;
    display: table;
    border-collapse: collapse;
    border-spacing: 0;

    tr {
      border-bottom: 1px solid rgba(0,0,0,.12);
    }

    td, th {
      padding: 15px 5px;
      display: table-cell;
      text-align: left;
      vertical-align: middle;
      border-radius: 2px;
    }
  }

  .code-sample-tabs {
    .tab-titles {
      display: flex;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .sample-title {
        font-weight: bold;
        padding: 0.5rem;
      }
      .langs {
        display: flex;
        flex-wrap: wrap;
        .tab-title {
          border-right: 2px solid #fdf6e3;
          padding: 0.25rem;
          font-size: 0.8rem;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          align-items: center;
          &:last-child {
            border-right: none;
          }
        }
      }
      .tab-title.selected {
        background-color: #fdf6e3;
        color: black;
      }
    }
    .tab-contents {
      .tab-content {
        display: none;
        opacity: 0;
        transition: opacity 1s;
      }
      .tab-content.show {
        display: block;
        opacity: 1;
      }
    }
  }

  ol,
  ul {
    &:not(.browser-default) {
        list-style-type: disc !important;
        padding-left: 2rem;
        margin: 0.5rem;
    }
  }

  p {
    margin-top: 6px;
    margin-bottom: 6px;
  }

  li {
    margin: 6px;
    list-style-type: disc !important;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }

  aside {
    > * {
      display: inline-block;
      vertical-align: top;
    }
    > span {
      padding-left: 6px;
      max-width: 90%;
    }
    > i {
      margin: 6px;
    }
    border-radius: 4px;
    padding: 10px;
    margin: 10px;
    &.success {
      background-color: #e6f6e5;
    }
    &.notice {
      background-color: #ccf1f0;
    }
    &.warning {
      background-color: #ffefaf;
    }
    &.error {
      background-color: #ffcec3;
    }
    code {
      background-color: rgba(0, 0, 0, 0.2);
      color: rgba(200, 0, 0, 1);
    }
  }

  thead {
    font-weight: bold
  }
  tbody {
    tr {
      border-top: 1px solid $tableRowColor;
      border-collapse: collapse;
      border-bottom: 1px solid $tableRowColor;
    }
  }

  .swagger-ui {
    div.model-example {
      ul {
        list-style-type: none !important;
        padding: 0px;
        li {
          margin: 0px;
          list-style-type: none !important;
        }
      }
    }
  }
`;
